import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-unauthorized.page.',
  templateUrl: './forbidden.page.component.html',
  styleUrls: ['./forbidden.page.component.sass'],
})
export class ForbiddenPageComponent implements OnInit {
  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * method to redirect
   */
  redirect(): void {
    const redirect = document.createElement('a');
    redirect.href = environment.principalMULink;
    redirect.target = '_blank';
    redirect.click();
  }
}
